import { DevtoolsOptions, PersistOptions } from 'zustand/middleware';
import { ApplicationStore } from '@data';
import merge from './merge';
import partialize, { PersistedState } from './partialize';

const APP_STORE_NAME = 'QMD-Application-Store';

export const devtoolsOptions: DevtoolsOptions = {
  name: APP_STORE_NAME,
};

export const persistOptions: PersistOptions<ApplicationStore, PersistedState> =
  {
    name: APP_STORE_NAME,
    partialize,
    merge,
  };
